import dayjs from "dayjs"
import relativeTime from "dayjs/plugin/relativeTime"
import timezone from "dayjs/plugin/timezone"

import { pluralize } from "@/lib/utils"

dayjs.extend(relativeTime)
dayjs.extend(timezone)

export const timeAgo = (date, noSuffix = false) => dayjs(date).fromNow(noSuffix)
export const toDate = (date, format = "MMM D, YYYY") =>
  dayjs(date).format(format)
export const toDateTime = (date, format = "MMM D, YYYY - hh:mm:ss A") =>
  toDate(date, format)
export const isPast = date => dayjs().isAfter(dayjs(date))
export const isFuture = date => dayjs().isBefore(dayjs(date))
export const toTime = (date, format = "hh:mm:ss A") => toDate(date, format)
export const startOf = (unit, date = new Date()) =>
  dayjs(date)
    .startOf(unit)
    .toDate()
export const timeBetween = (date1, date2) => {
  const from = dayjs(date1)
  const to = dayjs(date2)

  const secondsBetween = Math.abs(to.diff(from, "seconds"))

  if (secondsBetween < 60) {
    return `${secondsBetween} sec`
  } else if (secondsBetween < 3600) {
    const minutes = Math.floor(secondsBetween / 60)
    const seconds = String(secondsBetween % 60).padStart(2, "0")

    return `${minutes}${seconds > "00" ? `:${seconds}` : ""} min`
  } else if (secondsBetween < 216000) {
    const hours = Math.floor(secondsBetween / 3600)
    const minutes = String(Math.floor((secondsBetween / 60) % 60)).padStart(
      2,
      "0"
    )

    return `${hours}${minutes === "00" ? "" : `:${minutes}`} ${pluralize(
      "hour",
      hours
    )}`
  } else if (secondsBetween < 604800) {
    const days = to.diff(from, "days")

    return `${days} days`
  } else {
    const weeks = to.diff(from, "weeks")

    return `${weeks} weeks`
  }
}
export const parseEventTime = (
  startsAt,
  endsAt,
  isAllDay = false,
  full = true
) => {
  if (isAllDay) {
    return "All Day"
  } else {
    if (full) {
      return `${toTime(startsAt, `h:mm A`)} - ${toTime(endsAt, "h:mm A")}`
    } else {
      const formattedTime = `${toTime(
        startsAt,
        `h:mm${full ? " A" : ""}`
      )} - ${toTime(endsAt, "h:mm A")}`
      const timeSplit = formattedTime.split(" - ")
      const formattedParts = timeSplit.map(part => part.replace(":00", ""))

      return formattedParts.join(" - ")
    }
  }
}

export const isWithin = (date, unit, interval, compareTo = dayjs()) => {
  const difference = Math.abs(dayjs(date).diff(compareTo, interval))
  return difference <= unit - 1
}

export const secondsUntil = date => dayjs(date).diff(dayjs(), "second")

export const isSameDay = (date1, date2 = dayjs()) =>
  toDate(date1) === toDate(date2)

export const add = (unit, interval = "day", date = new Date()) =>
  dayjs(date)
    .add(unit, interval)
    .toDate()
export const subtract = (unit, interval = "day", date = new Date()) =>
  dayjs(date)
    .subtract(unit, interval)
    .toDate()

export const daysBetweenDates = (start, end, format = "YYYY-MM-DD") => {
  let dateArray = new Array()
  let currentDate = dayjs(start)

  while (currentDate <= dayjs(end)) {
    dateArray.push(format ? currentDate.format(format) : currentDate.toDate())
    currentDate = currentDate.add(1, "day")
  }

  return dateArray
}

export const dayOfMonth = date => dayjs(date).date()
export const getUserTimezone = () => dayjs.tz.guess()
